<div class="voice-assistant-overlay" [class.voice-assistant-overlay--docked]="isDocked()" (click)="onOverlayClick()">
  <div class="voice-assistant-card glass" (click)="onCardClick($event)">
    <button class="close-btn" type="button" (click)="closeFromButton($event)" title="Close Voice Assistant" aria-label="Close Voice Assistant">
      <i class="fas fa-times"></i>
    </button>

    <div class="card-content">
      <div class="voice-brand hj-brand-lockup">
        <span class="hj-brand-mark hj-brand-mark--voice" aria-hidden="true">
  <span class="hj-brand-face">
    <span class="hj-brand-eye hj-brand-eye--left"></span>
    <span class="hj-brand-eye hj-brand-eye--right"></span>
    <span class="hj-brand-smile"></span>
    <span class="hj-brand-spark hj-brand-spark--one"></span>
    <span class="hj-brand-spark hj-brand-spark--two"></span>
  </span>
</span>
        <span class="hj-brand-word voice-brand-mode">{{ brandLabel() }}</span>
      </div>

      <!-- Status Badge -->
      <div class="status-badge" [ngClass]="status()">
        <span class="status-dot"></span>
        <span class="status-text">
          <ng-container [ngSwitch]="status()">
            <span *ngSwitchCase="'listening'">{{ assistantMode() ? 'Listening...' : modeChoiceStatus() }}</span>
            <span *ngSwitchCase="'processing'">Jivu is thinking...</span>
            <span *ngSwitchCase="'speaking'">Speaking...</span>
            <span *ngSwitchCase="'error'">System Alert</span>
            <span *ngSwitchDefault>{{ assistantMode() ? 'Ready' : modeChoiceStatus() }}</span>
          </ng-container>
        </span>
      </div>

      <!-- Animated Visualizer Waves -->
      <div class="visualizer-wrapper">
        <div class="visualizer-waves" [ngClass]="status()">
          <!-- Listening Waves -->
          <ng-container *ngIf="status() === 'listening'">
            <div class="hj-ripple hj-ripple--one"></div>
            <div class="hj-ripple hj-ripple--two"></div>
            <div class="hj-ripple hj-ripple--three"></div>
            <div class="visualizer-center listening">
              <span class="hj-brand-mark hj-brand-mark--voice" aria-hidden="true">
  <span class="hj-brand-face">
    <span class="hj-brand-eye hj-brand-eye--left"></span>
    <span class="hj-brand-eye hj-brand-eye--right"></span>
    <span class="hj-brand-smile"></span>
    <span class="hj-brand-spark hj-brand-spark--one"></span>
    <span class="hj-brand-spark hj-brand-spark--two"></span>
  </span>
</span>
              <i class="visualizer-status-icon fas fa-microphone"></i>
            </div>
          </ng-container>

          <!-- Thinking / Processing Waves -->
          <ng-container *ngIf="status() === 'processing'">
            <div class="hj-spinner-ring"></div>
            <div class="visualizer-center processing">
              <span class="hj-brand-mark hj-brand-mark--voice" aria-hidden="true">
  <span class="hj-brand-face">
    <span class="hj-brand-eye hj-brand-eye--left"></span>
    <span class="hj-brand-eye hj-brand-eye--right"></span>
    <span class="hj-brand-smile"></span>
    <span class="hj-brand-spark hj-brand-spark--one"></span>
    <span class="hj-brand-spark hj-brand-spark--two"></span>
  </span>
</span>
              <i class="visualizer-status-icon fas fa-brain fa-pulse"></i>
            </div>
          </ng-container>

          <!-- Speaking Waves -->
          <ng-container *ngIf="status() === 'speaking'">
            <div class="hj-wave-bar-container">
              <div class="hj-wave-bar hj-wave-bar--one"></div>
              <div class="hj-wave-bar hj-wave-bar--two"></div>
              <div class="hj-wave-bar hj-wave-bar--three"></div>
              <div class="hj-wave-bar hj-wave-bar--four"></div>
              <div class="hj-wave-bar hj-wave-bar--five"></div>
            </div>
            <div class="visualizer-center speaking">
              <span class="hj-brand-mark hj-brand-mark--voice" aria-hidden="true">
  <span class="hj-brand-face">
    <span class="hj-brand-eye hj-brand-eye--left"></span>
    <span class="hj-brand-eye hj-brand-eye--right"></span>
    <span class="hj-brand-smile"></span>
    <span class="hj-brand-spark hj-brand-spark--one"></span>
    <span class="hj-brand-spark hj-brand-spark--two"></span>
  </span>
</span>
              <i class="visualizer-status-icon fas fa-volume-up"></i>
            </div>
          </ng-container>

          <!-- Error / Idle State -->
          <ng-container *ngIf="status() === 'error' || status() === 'idle'">
            <div class="visualizer-center" [class.error]="status() === 'error'">
              <i [class]="status() === 'error' ? 'fas fa-exclamation-triangle' : 'fas fa-microphone-slash'"></i>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="mode-choice" *ngIf="!assistantMode()">
        <p class="mode-kicker">{{ canUseTalkMode() ? 'Choose how Jivu should help' : 'Tool navigation is available on this plan' }}</p>
        <div class="mode-choice-grid">
          <button class="mode-choice-btn mode-choice-btn--work" type="button" (click)="selectMode('work')">
            <i class="fas fa-briefcase"></i>
            <span>
              <strong>Tool navigation</strong>
              <small>Open any tool</small>
            </span>
          </button>
          <button *ngIf="canUseTalkMode()" class="mode-choice-btn mode-choice-btn--talk" type="button" (click)="selectMode('talk')">
            <i class="fas fa-comment-dots"></i>
            <span>
              <strong>Talk Mode</strong>
              <small>Just chat</small>
            </span>
          </button>
        </div>
      </div>

      <div class="active-mode-pill" *ngIf="assistantMode()">
        <i [class]="assistantMode() === 'work' ? 'fas fa-compass' : 'fas fa-comment-dots'"></i>
        <span>{{ assistantMode() === 'work' ? 'Tool navigation is on' : 'Talk is on' }}</span>
      </div>

      <button
        *ngIf="canOpenJivuBar()"
        class="jivu-bar-btn"
        type="button"
        (click)="openJivuBar($event)"
        title="Open Jivu Bar"
        aria-label="Open Jivu Bar"
      >
        <i class="fas fa-window-restore"></i>
        <span>Jivu Bar</span>
      </button>

      <div class="voice-error-panel" *ngIf="status() === 'error'">
        {{ errorMessage() }}
      </div>

      <!-- Action Buttons -->
      <div class="action-footer">
        <button 
          *ngIf="status() === 'listening' && assistantMode() && transcript().trim()" 
          class="send-now-btn" 
          [disabled]="!transcript().trim()"
          (click)="sendToBrain()"
        >
          <i class="fas fa-paper-plane mr-2"></i> Send Now
        </button>

        <button 
          *ngIf="status() === 'speaking'" 
          class="stop-now-btn" 
          (click)="stopSpeaking()"
        >
          <i class="fas fa-stop mr-2"></i> Stop Speaking
        </button>

        <button 
          *ngIf="status() === 'error'" 
          class="retry-btn" 
          (click)="startSession()"
        >
          <i class="fas fa-redo mr-2"></i> Try Again
        </button>
      </div>

    </div>
  </div>
</div>


